module.exports = __webpack_public_path__ + "static/media/logo_cropped.06788016.jpg";